import { render, staticRenderFns } from "./PaidStatusBadge.vue?vue&type=template&id=4ec4b497&scoped=true&"
import script from "./PaidStatusBadge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PaidStatusBadge.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PaidStatusBadge.vue?vue&type=style&index=0&id=4ec4b497&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4b497",
  null
  
)

export default component.exports